import { theme, Box, Anchor } from '@bpba/ui-components';
import { CARROUSEL_RADIUS } from '../../constants/styles';
import { MenuIcon } from '../../model/novedades/MenuIcon';
import { SvgIcon } from '../shared/SvgIcon';
import { useState } from 'react';

type MenuIconComponentProps = {
  item: MenuIcon;
  funcion?: () => void;
};

export function MenuIconComponent(props?: MenuIconComponentProps) {
  const [showLabel, setShowLabel] = useState(false);

  function onHoverStart() {
    if (props?.item?.titulo) setShowLabel(true);
  }
  function onHoverEnd() {
    setShowLabel(false);
  }

  if (!props?.item || !props.item.icono) return <></>;

  return (
    <Anchor
      data={props.item}
      display="flex"
      width="fit-content"
      marginBottom="6px"
      onMouseOver={onHoverStart}
      onMouseOut={onHoverEnd}
      backgroundColor={showLabel ? theme.colors.secondary[1] : ''}
      borderBottomRightRadius={CARROUSEL_RADIUS}
      borderTopRightRadius={CARROUSEL_RADIUS}
      title={props.item.titulo}
      onClick={props.funcion}
    >
      <Box
        backgroundColor={theme.colors.primary[0]}
        width="54px"
        height="36px"
        padding="14px"
        alignItems="center"
        justifyContent="center"
        borderBottomRightRadius={CARROUSEL_RADIUS}
        borderTopRightRadius={CARROUSEL_RADIUS}
      >
        <SvgIcon imageSvg={props.item.icono} width="100%" fill={theme.colors.white} color={theme.colors.white} />
      </Box>
      <Box
        paddingLeft="12px"
        paddingRight="12px"
        color="white"
        width="auto"
        alignItems="center"
        justifyContent="center"
        borderBottomRightRadius={CARROUSEL_RADIUS}
        borderTopRightRadius={CARROUSEL_RADIUS}
        display={showLabel ? 'flex' : 'none'}
      >
        {props.item.titulo}
      </Box>
    </Anchor>
  );
}
